import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import classNames from 'classnames';
import counterpart from 'counterpart';
import { connect } from 'react-redux';
import { difference } from 'Utils/lodashUtils';
import { initCommonTranslate } from 'Utils/languages';
import Listener from 'Utils/listener';
import { checkForSingularReportId } from 'Utils/reports/checkForSingularReportId';
import { setAmexDisputeReasonCode } from 'Actions/reasonCodeAction';
import PrimaryNavigation from '../PrimaryNavigation';
import { navItems } from './data/constants';
import './Navigation.scss';
import { unloadAllCases, unloadCaseAsActive, unloadCaseInfo } from '../../actions/caseActions';
import { loadActiveCases } from '../../store/browserStorage';
import OneGPIcon from 'Components/icons/OneGPIcon';
import OneGPIconShort from 'Components/icons/OneGPIconShort';
import CollapseIcon from 'Components/icons/CollapseIcon';
import ExpandIcon from 'Components/icons/ExpandIcon';

export class Navigation extends Component {
  constructor(props) {
    super(props);

    initCommonTranslate();

    this.state = {
      subNavTriggered: false,
      subNavActive: null,
      navKeys: [],
      navIsClosed: false,
      activeCases: []
    };

    this.attachBindings();
  }

  componentDidMount() {
    this.mapNavKeys();
    this.mapSecondaryNavKeys();
    this.triggerSubNav();
    this.setState({
      activeCases: loadActiveCases()
    });
  }

  checkOldandNewCasesEqual(oldCases, newCases) {
    if (oldCases === newCases) return true;
    if (oldCases == null || newCases == null) return false;
    if (oldCases.length !== newCases.length) return false;
    oldCases.sort();
    newCases.sort();
    for (var i = 0; i < oldCases.length; ++i) {
      if (oldCases[i] !== newCases[i]) return false;
    }
    return true;
  }

  componentWillReceiveProps() {
    this.triggerSubNav();

    this.setState((prevState) => {
      if (prevState.subNavTriggered && prevState.navIsClosed) {
        this.setState({ triggerSubNavAnimation: true });
      }
    });

    window.addEventListener('storage', () => {
      const storageActiveCases = loadActiveCases()
      if (storageActiveCases.length < this.state.activeCases.length) {
        const releasedCases = difference(this.state.activeCases, storageActiveCases);
        if (releasedCases.length === 1) {
          this.unlockCurrentCase(releasedCases[0])
        } else {
          this.unlockAllCurrentCases(releasedCases)
        }
        this.setState({
          activeCases: storageActiveCases
        })
      }
      else if (storageActiveCases.length !== this.state.activeCases.length) {
        this.setState({
          activeCases: storageActiveCases
        })
      }
    });
  }

  componentDidUpdate(prevProps) {
    const { width, location } = this.props;
    const { subNavTriggered, navKeys, secondaryNavKeys } = this.state;
    const slugMatches = this.checkIfSlugMatches(location, prevProps);
    const slugDoesntMatch = this.checkifSlugDoesNotMatch(location, prevProps);
    const articleDoesNotMatch = this.checkIfArticleDoesNotMatch(location, prevProps, secondaryNavKeys);
    const routeIsNavigable = this.checkIfRouteIsNavigable(navKeys, location);
    const widthAndRoutePresent = width <= 1024 && routeIsNavigable;

    if (widthAndRoutePresent
      && ((slugMatches && articleDoesNotMatch && subNavTriggered)
        || (slugDoesntMatch && !subNavTriggered))) {
      Listener.trigger('ROUTE_CHANGE');
    }

    if (this.props.location.pathname !== prevProps.location.pathname && !!this.props.location.pathname) {
      this.props.setAmexDisputeReasonCode("");
    }
    const storageActiveCases = loadActiveCases();
    if (storageActiveCases.length !== this.state.activeCases.length) {
      this.setState({
        activeCases: storageActiveCases
      })
    }
  }

  checkIfRouteIsNavigable(navKeys, location) {
    return location.pathname === '/' || navKeys.indexOf(location.pathname.split('/')[1].replace(/\//g, '')) > -1;
  }

  checkIfSlugMatches(location, prevProps) {
    return location.pathname.split('/')[1] === prevProps.location.pathname.split('/')[1];
  }

  checkifSlugDoesNotMatch(location, prevProps) {
    return location.pathname !== prevProps.location.pathname;
  }

  checkIfArticleDoesNotMatch(location, prevProps, secondaryNavKeys) {
    return location.pathname.split('/')[2] !== prevProps.location.pathname.split('/')[2]
      && secondaryNavKeys.indexOf(location.pathname) > -1;
  }

  mapNavKeys() {
    const translatedNavItems = navItems();

    const navKeys = translatedNavItems.map((item) => item.slug);

    this.setState({ navKeys });
  }

  mapSecondaryNavKeys = () => {
    const translatedNavItems = navItems();

    const paths = translatedNavItems.filter((item) => item.children.length > 0).map((item) => item.children.map((child) => child.path));
    const secondaryNavKeys = [].concat(...paths);

    this.setState({ secondaryNavKeys });
  }

  attachBindings() {
    this.mapNavKeys = this.mapNavKeys.bind(this);
    this.goBackToMain = this.goBackToMain.bind(this);
    this.triggerSubNav = this.triggerSubNav.bind(this);
    this.checkIfSlugMatches = this.checkIfSlugMatches.bind(this);
    this.checkifSlugDoesNotMatch = this.checkifSlugDoesNotMatch.bind(this);
    this.checkIfRouteIsNavigable = this.checkIfRouteIsNavigable.bind(this);
    this.checkIfArticleDoesNotMatch = this.checkIfArticleDoesNotMatch.bind(this);
    this.unlockCurrentCase = this.unlockCurrentCase.bind(this);
    this.unlockAllCurrentCases = this.unlockAllCurrentCases.bind(this);
    this.unloadAllCaseInfo = this.unloadAllCaseInfo.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  goBackToMain() {
    if (this.state.subNavTriggered) {
      this.setState({
        subNavActive: null,
        subNavTriggered: false,
        subNavChildren: [],
      }, () => {
        this.props.history.push('/');
      });
    }
  }

  unloadAllCaseInfo(caseNumbers) {
    return caseNumbers.map(caseNumber => {
      return this.props.unloadCaseInfo(caseNumber)
    });
  }

  unlockCurrentCase(caseNumber) {
    return this.props.unloadCaseAsActive(caseNumber), this.props.unloadCaseInfo(caseNumber);
  }

  unlockAllCurrentCases(caseNumbers) {
    return this.props.unloadAllCases(caseNumbers), this.unloadAllCaseInfo(caseNumbers);
  }

  triggerSubNav(event) {
    const { subNavActive } = this.state;
    const { featureFlags } = this.props;

    const newState = {
      subNavTriggered: false,
      subNavActive: null,
      menuTitleText: counterpart('globalTranslate.navigation.defaultTitleText'),
      subNavChildren: [],
    };

    const translatedNavItems = navItems();

    for (let i = 0; i < translatedNavItems.length; i += 1) {
      const navItem = translatedNavItems[i];
      if (this.props.history.location.pathname.split('/')[1] === navItem.key) {
        newState.subNavTriggered = (
          navItem.children.length > 0
          && !featureFlags[navItem.hideSubNavOnFlag]
        );
        newState.subNavActive = (featureFlags[navItem.hideSubNavOnFlag])
          ? null
          : navItem.key;
        newState.menuTitleText = navItem.title;
        newState.hideSubNavOnFlag = navItem.hideSubNavOnFlag;

        for (let j = 0; j < navItem.children.length; j += 1) {
          if (navItem.children[j].path === '/report/7' && !checkForSingularReportId(this.props.auth.session.user.hierarchyReports, 7)) {
            navItem.children.splice(j, 1);
          }
          if (navItem.children[j].path === '/account-management/product-offering' && !this.props.auth.session.user.parsedPermissions.merchants.canViewProductSelection) {
            navItem.children.splice(j, 1);
          }
        }
        newState.subNavChildren = navItem.children;

        break;
      }
    }

    if (this.props.history.location.pathname === '/account-management/product-offering') {
      this.props.auth.session.isSearched = false;
    }

    this.setState(newState, () => {
      const noSubNav = (
        (subNavActive === null
          && newState.subNavActive === null)
        || this.props.featureFlags[newState.hideSubNavOnFlag]
      );

      if (event && !noSubNav) {
        this.props.transitionEndAnimation();
        this.setState({ navIsClosed: false });
      }

      if (noSubNav) {
        this.setState({ navIsClosed: true });
      }
    });
  }

  handleMouseEnter = () => {
    if (this.props.navCollapsed === "expanded") {
      this.props.handleNavExpandedOnHover(true);
    }
  };

  handleMouseLeave = () => {
    if (this.props.navCollapsed === "expanded") {
      this.props.handleNavExpandedOnHover(false);
    }
  };

  render() {
    const navClasses = classNames('primary-nav', {
      'with-overlay': this.props.overlayClass !== null && this.props.overlayClass,
      collapsed: this.state.subNavTriggered,
      'navigation-toggled': this.props.navigationToggled,
    });

    const headerClasses = classNames('primary-nav__header', {
      collapsed: this.state.subNavTriggered,
    });

    const wrapperClasses = classNames('nav-wrapper', {
      collapsed: this.state.subNavTriggered,
    });

    const verticalNavClasses = classNames('vertical-nav', {
      collapsed: this.state.subNavTriggered,
    });

    const navActionClasses = classNames('vertical-nav-action', {
      collapsed: this.state.subNavTriggered,
    });

    const iconClasses = classNames('vertical-nav-icon', {
      collapsed: this.state.subNavTriggered,
    });

    const labelClasses = classNames('vertical-nav-label', {
      collapsed: this.state.subNavTriggered,
    });

    return (
      <nav id="primary-nav" className={navClasses} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
        <div className={wrapperClasses}>

          <div className="disputes-brand">
            {!this.props.isNavExpandedOnHover ? <OneGPIconShort /> : <OneGPIcon />}
          </div>

          {!this.props.isNavExpandedOnHover ? <div className="vertical-nav-menu-label">MENU</div> : <div className="sc-hvigdm sc-fhHczv kcTHpN kTbYFY"><div>DISPUTES MANAGEMENT</div><button type="button" class="nav-collapse" aria-label="missing translation: EN.globalTranslate.navigation.toggleNavigation" 
            onClick={() => this.props.toggleNavState()}
          >
            {
              this.props.navCollapsed === "collapsed" ? <CollapseIcon
              /> : <ExpandIcon />
            }
          </button></div>}

          <PrimaryNavigation
            featureFlags={this.props.featureFlags}
            user={this.props.user}
            navActionClasses={navActionClasses}
            verticalNavClasses={verticalNavClasses}
            iconClasses={iconClasses}
            labelClasses={labelClasses}
            messages={{}}
            triggerSubNav={this.triggerSubNav}
            transitionEnded={this.props.transitionEnded}
            subNavTriggered={this.state.subNavTriggered}
            reportList={this.props.reportList}
            recentCases={this.state.activeCases ? this.state.activeCases : []}
            navCollapsed={this.props.isNavExpandedOnHover ? "expanded" : this.props.navCollapsed === "expanded" ? "collapsed" : "expanded"}
            unlockCurrentCase={this.unlockCurrentCase}
            unlockAllCurrentCases={this.unlockAllCurrentCases}
          />

          {/* <button onClick={this.props.toggleNavState} type="button" className="nav-collapse">
            <svg viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.2794 0C17.5556 0 17.7794 0.223857 17.7794 0.5V1.21429C17.7794 1.49043 17.5556 1.71429 17.2794 1.71429H8.85085C8.57471 1.71429 8.35085 1.49043 8.35085 1.21429V0.5C8.35085 0.223858 8.57471 0 8.85085 0H17.2794Z" fill="white" />
              <path d="M17.2794 5.14286C17.5556 5.14286 17.7794 5.36671 17.7794 5.64286V6.35714C17.7794 6.63329 17.5556 6.85714 17.2794 6.85714H3.08687L4.92377 8.69404C5.11904 8.88931 5.11904 9.20589 4.92377 9.40115L4.4187 9.90623C4.22344 10.1015 3.90685 10.1015 3.71159 9.90623L0.176058 6.37069C0.0731201 6.26776 0.0244484 6.1311 0.0300446 5.99628C0.0244484 5.86145 0.0731201 5.7248 0.176058 5.62186L3.71159 2.08633C3.90685 1.89107 4.22344 1.89106 4.4187 2.08633L4.92377 2.5914C5.11904 2.78667 5.11904 3.10325 4.92377 3.29851L3.07943 5.14286H17.2794Z" fill="white" />
              <path d="M17.7794 10.7857C17.7794 10.5096 17.5556 10.2857 17.2794 10.2857H8.85085C8.57471 10.2857 8.35085 10.5096 8.35085 10.7857V11.5C8.35085 11.7761 8.57471 12 8.85085 12H17.2794C17.5556 12 17.7794 11.7761 17.7794 11.5V10.7857Z" fill="white" />
            </svg>
          </button> */}

        </div>
      </nav>
    );
  }
}

Navigation.propTypes = {
  auth: PropTypes.object.isRequired,
  featureFlags: PropTypes.object,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  navigationToggled: PropTypes.bool,
  overlayClass: PropTypes.string,
  transitionEndAnimation: PropTypes.func,
  transitionEnded: PropTypes.bool,
  width: PropTypes.number,
  reportList: PropTypes.array.isRequired,
  activeCases: PropTypes.array.isRequired,
  navCollapsed: PropTypes.string,
};

Navigation.defaultProps = {
  featureFlags: {},
  navigationToggled: false,
  overlayClass: '',
  transitionEnded: true,
  transitionEndAnimation: () => { },
  width: null,
  navCollapsed: 'expanded',
  activeCases: [],
  isNavExpanded: false,
  isNavExpandedOnHover: false,
};

const mapStateToProps = (state) => ({
  auth: {},
  featureFlags: {},
  user: state.auth.user,
  reportList: [],
  activeCases: state.activeCases
});

const mapDispatchToProps = (dispatch) => {
  return {
    unloadCaseAsActive: (caseNumber, caseStageId) => {
      dispatch(unloadCaseAsActive(caseNumber, caseStageId));
    },
    unloadAllCases: (caseNumbers) => {
      dispatch(unloadAllCases(caseNumbers));
    },
    setAmexDisputeReasonCode: (amexDisputeReasonCode) => {
      dispatch(setAmexDisputeReasonCode(amexDisputeReasonCode));
    },
    unloadCaseInfo: (caseNumber) => {
      dispatch(unloadCaseInfo(caseNumber));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Navigation));
